import { render, staticRenderFns } from "./codeInput2.vue?vue&type=template&id=6f739fb0&scoped=true&"
import script from "./codeInput2.vue?vue&type=script&lang=js&"
export * from "./codeInput2.vue?vue&type=script&lang=js&"
import style0 from "./codeInput2.vue?vue&type=style&index=0&id=6f739fb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f739fb0",
  null
  
)

export default component.exports